import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';

export const Container = styled.div`
  ${removeScrollbar()}

  display: flex;
  gap: 10px;
  overflow-x: auto;
`;

export const Tab = styled(Typography.Body).attrs({ as: 'button' })<{
  $isActive: boolean;
}>`
  height: 40px;
  padding: 0 15px;
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;

  ${({ theme, $isActive }) =>
    $isActive
      ? css`
          color: ${theme.palette.system.white};
          background-color: ${theme.palette.brand.main};
        `
      : css`
          color: ${theme.palette.primary.labels};
          background-color: ${theme.palette.secondary.background};
        `}
`;
